import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useSWRImmutable from 'swr/immutable';

import { AuthenticationBanners } from '@/api/cms';
import { fetcherCMS } from '@/modules/api';
import {
  createCMSQuery,
  getCMSImageFieldsUrl,
  getCMSLocale,
} from '@/modules/cms';
import { useCommonStore } from '@/store';

export const useCMSAuthenticationBanner = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const user = useCommonStore.use.user();

  const populatePattern = {
    populate: {
      ...getCMSImageFieldsUrl('background'),
      ...getCMSImageFieldsUrl('characters'),
    },
  };

  const query = useMemo(() => {
    return createCMSQuery({
      populate: {
        registration_v2: populatePattern,
        login: populatePattern,
      },
      ...getCMSLocale(language),
    });
  }, [language]);

  const {
    data = null,
    error,
    isLoading,
  } = useSWRImmutable<AuthenticationBanners>(
    `/authentication-banner?${query}`,
    fetcherCMS
  );

  return {
    banners: data,
    error,
    isLoading,
  };
};
